import $ from '../../../../../FrontendBundle/Resources/js/jquery';
import SetItemSizeCommand from '../command/setItemSizeCommand';
import DropdownField from './dropdownField';

/**
 * @class SizeField
 */
export default class SizeField extends DropdownField {
    type = 'size';
    supports = null;

    getDropdownTemplateString() {
        return `
            <li<% if (active) { %> class="active"<% } %>>
                <a href="" data-item="<%= key %>" data-type="<%= type %>">
                    <% if (!available) { %><span class="unavailable"><i class="icon-truck"></i></span><% } %>
                    <%= value %>
                </a>
            </li>
        `;
    }

    /**
     * Register click event on dropdown.
     *
     * @param {jQuery} dropdown
     */
    registerEventsForDropdown(dropdown) {
        dropdown.on('click', 'li a', async (e) => {
            const target = $(e.target);
            const itemId = target.data('item');
            const itemType = target.data('type');
            const canvas = this.editor.getCanvas();
            const history = canvas.getHistory();
            const selection = canvas.getSelection();
            const item = selection.first();
            const itemFactory = canvas.getItemFactory();

            const newItem = await itemFactory.create(
                itemType,
                { itemId },
                item.getParentItem(),
            );
            newItem.set('position', item.get('position'));
            newItem.set('rotation', item.get('rotation'));

            const command = new SetItemSizeCommand(
                item.getParentItem().getItems(),
                selection,
                [{
                    oldItem: item,
                    newItem,
                }],
            );

            history.addAndExecuteCommand(command);
        });
    }

    /**
     * Update text with item value.
     *
     * @param {ItemInterface} item
     */
    updateText(item) {
        this.button.children('.text').text(item.get('size'));
    }

    /**
     * Update text with item value.
     *
     * @param {ItemInterface} item
     */
    updateOptions(item) {
        const productionDataStore = this.editor.getCanvas().getItemFactory().getProductionDataStore();
        const productFamily = productionDataStore.getProductFamilyForItem(item);
        const sizeOptions = productFamily.getSizeOptions(item);

        this.setOptions(sizeOptions);
    }

    /**
     * Update item with field value.
     */
    updateItem() {}

    /**
     * Check if field is supportet by item.
     *
     * @param {ItemInterface} item
     * @param {number} selectionLength
     *
     * @return {boolean}
     */
    isSupported(item, selectionLength) {
        if (!(selectionLength === 1 && item && item.supportsAlign)) {
            return false;
        }

        try {
            const productionDataStore = this.editor.getCanvas().getItemFactory().getProductionDataStore();
            const productFamily = productionDataStore.getProductFamilyForItem(item);
            const sizeOptionsCount = productFamily.countSizeOptions(item);

            return sizeOptionsCount > 1;
        } catch (e) {
            return false;
        }
    }
}
